export const getters = {
  club: state => state.club,
  clubs: state => state.clubs,
  clubInfo: state => state.clubInfo,
  groupList: state => state.groupList,
  eventCatalogs: state => state.eventCatalogs
};
